var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLcPrivateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.00035C7.23594 6.00035 8.64286 4.65707 8.64286 3.00018C8.64286 1.34328 7.23594 0 5.5 0C3.76406 0 2.35714 1.34328 2.35714 3.00018C2.35714 4.65707 3.76406 6.00035 5.5 6.00035ZM6.74487 7.12542H4.25513C1.9056 7.12542 0 8.94427 0 11.1874C0 11.636 0.381071 12 0.851027 12H10.1495C10.6194 12.0007 11 11.6374 11 11.1874C11 8.94427 9.09464 7.12542 6.74487 7.12542Z",
    fill: "#1C803C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLcPrivateIcon);
export default __webpack_public_path__ + "static/media/lc-private-icon.03c7d120f4b0151b642149931f207d31.svg";
export { ForwardRef as ReactComponent };